import "./extend/date.js";
import {DynamicScroller} from "./scroller.js";


export class ClassRegisterScroller extends DynamicScroller {

   constructor(settings, classRegister) {
      super({ transitionDuration: 400 });
 
      this.classRegister = classRegister;

      // Render-order festlegen. Diese bestimmt, in welcher Reihenfolge der Buffer gefüllt wird.
      // Im Fall des Klassenbuchs soll zuerst der aktuelle Tag und die zurückligeneden Tage gefüllt werden,
      // danach erst die in der Zukunft liegenden.
      this.renderOrder = [];
      for (let i=this.set.bufferSize; i >= 0; --i) this.renderOrder.push(i);
      for (let i=this.set.bufferSize+1; i<this.elContainer.children.length; ++i) this.renderOrder.push(i);
 
      // relevante Wochentage (nur diese werden angezeigt)
      this.relevantWeekdays = [0,1,2,3,4];
 
   }
 
    setCurrentDate(date) {

      if (!this.relevantWeekdays.includes(date.getWeekday())) date.nextDay(this.relevantWeekdays);

      this.loadItems();

      this.currentDate = date;

      // Die einzelnen Buffer-Elemente mit den Daten der (relevanten) Tage füllen
      let d = new Date(date);
      for (let i=0; i<this.set.bufferSize; ++i) d.prevDay(this.relevantWeekdays);

      for (let i=0; i < this.elContainer.children.length; ++i) {
         const el = this.elContainer.children[i];
         el.dataset.isoDate = d.isoDate();
         el.dataset.rendering = el.dataset.rendered = false;
         this.classRegister.initDay(el);
         d.nextDay(this.relevantWeekdays);         
      }

      this.classRegister.elDate.innerHTML = this.currentDate.toGermanDate(true, true);

      // Buffer laden
      this.fillBuffer();

   }
    
    onFlipped(element, s) {
 
      // aktuelles Datum anpassen
      if (s < 0) this.currentDate.nextDay(this.relevantWeekdays);
      else       this.currentDate.prevDay(this.relevantWeekdays);

      // dem geflippeten Element das entsprechende Datum zuweisen
      let newDate = new Date(this.currentDate);
      if (s < 0) for (let i=0; i<this.set.bufferSize; ++i) newDate.nextDay(this.relevantWeekdays);
      else       for (let i=0; i<this.set.bufferSize; ++i) newDate.prevDay(this.relevantWeekdays);
      element.dataset.isoDate = newDate.isoDate();

      this.classRegister.elDate.innerHTML = this.currentDate.toGermanDate(true, true);

      super.onFlipped(element, s);
 
   }
 
   async renderItem(element) {
      await this.classRegister.loadDay(element, element.dataset.isoDate);
   }
 
 }
 
